import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./ConfirmationModal.css"
import axios from "axios";
import { USER_EXCHNAGE_URL } from "../../../../Url/Url";
import { toast } from "react-toastify";
import { FaEnvelopeCircleCheck } from "react-icons/fa6";
import { RedBackgroundButton, Redbutton } from "../../../Global/GlobalButton";
import {
    GreenDescription,
    LoginSubHeading,
    RegisterGreenHeading,
    RegisterGreyHeading,
  } from "../../../Global/GlobalText";
import Modal from "react-bootstrap/Modal";

export default function ConfirmationModal() {
    const [isOpen, setIsOpen] = useState(true);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [show, setShow] = useState(true);
    const handleClose = () => setShow(false);
    const location = useLocation();
    const getQueryParam = (param) => {
        const searchParams = new URLSearchParams(location.search);
        return searchParams.get(param);
    };
    const email = getQueryParam("email"); 

    const handleConfirm = async () => {
        try {
            const response = await axios.post(
                `${USER_EXCHNAGE_URL}/verifyUser?email=${email}`
            );
            toast.success("Registration confirmed successfully!");
            const eventPrefix = localStorage.getItem("eventprefix")
            navigate(eventPrefix)
        } catch (error) {
            toast.error("Failed to confirm registration. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
        {/* <Modal show={show} onHide={handleClose} size="lg" centered>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="userflow_modal">
            <div className="user_flow_icon">
              <FaEnvelopeCircleCheck />
              <GreenDescription>Thank You for Registering {email} over Award Suite</GreenDescription>
            </div>
            <div className="user_flow_content">
             
              <RegisterGreyHeading>
                "Kindly Click on the below button to confirm your Registration"
              </RegisterGreyHeading>
            </div>
            <div className="userflow_comfirm_button">
              <RedBackgroundButton
                onClick={handleConfirm}
              >
                Confirm
              </RedBackgroundButton>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal> */}


      <Modal show={show} onHide={handleClose} size="lg" centered>
  <Modal.Header closeButton></Modal.Header>
  <Modal.Body>

    <div className="confirmation-modal-wrapper">

      <div className="userflow_modal">
        <div className="user_flow_icon">
          <FaEnvelopeCircleCheck />
          <GreenDescription>
            Thank You for Registering {email} over Award Suite
          </GreenDescription>
        </div>

        <div className="user_flow_content">
          <RegisterGreyHeading>
            Kindly Click on the below button to confirm your Registration
          </RegisterGreyHeading>
        </div>

        <div className="userflow_comfirm_button">
          <RedBackgroundButton onClick={handleConfirm}>
            Confirm
          </RedBackgroundButton>
        </div>

      </div>

    </div>

  </Modal.Body>
</Modal>
      </>
    );
}
